import React from 'react';
import Button from 'components/Button';

import Modal from 'antd/lib/modal/Modal';
import DF from 'DisplayFramework';
import MarketingPictures from './MarketingPictures';
import { Card, FormInstance } from 'antd';
import GetLabel from 'DisplayFramework/components/GetLabel';

type marketingLabelModalprops = {
  onCancel: () => void;
  onSuccess: () => void;
  visible: boolean;
  ParMarketingResponse: any;
  list?: any;
  form: FormInstance;
  onValidatePicture?: (url: string) => void;
};

const MarketingLabelModal = ({
  visible,
  onCancel,
  ParMarketingResponse,
  form,
  onSuccess,
  onValidatePicture,
}: marketingLabelModalprops) => {
  return (
    <DF.Provider pagcode="mclabeldetail">
      <Modal
        visible={visible}
        onCancel={onCancel}
        width={1500}
        title={<GetLabel label="Modal Pictures" />}
        footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
      >
        <Card>
          <MarketingPictures
            mc={ParMarketingResponse}
            mainForm={form}
            onSuccess={() => {
              onSuccess();
            }}
            onValidatePicture={onValidatePicture}
          />
        </Card>
      </Modal>
    </DF.Provider>
  );
};

export default MarketingLabelModal;
